import React from 'react'
import './styles.scss'

const WrapperSignOption = ({ children }) => <div className="wrapper-sign-option">{children}</div>
export default WrapperSignOption
